module.exports = __webpack_public_path__ + "img/pontooh.640de7af.png";